// Specific polyfills for older browsers
import "core-js/stable/object/from-entries";
import "core-js/features/bigint";
import "./index.css";
import "@stepfinance/react/index.css";

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { LanguageContextProvider } from "./contexts/language/language";
import * as serviceWorker from "./serviceWorker";

if (process.env.REACT_APP_SENTRY_ENABLED === "true") {
  Sentry.init({
    dsn: "https://06e7eb512e024754b080d80cfc36aa10@o976385.ingest.sentry.io/5932739",
    integrations: [new Integrations.BrowserTracing()],
    environment: process.env.REACT_APP_SENTRY_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    ignoreErrors: [
      "TypeError: Failed to fetch", // temporary disable this while solana network/rpc nodes pozzed
      "Wallet disconnected",
      "Wallet not connected",
      "503 Service Unavailable",
      "NetworkError when attempting to fetch resource.",
      "The network connection was lost.",
      "failed to get info about account",
      "The request timed out",
      "Account does not exist",
      "User rejected the request.",
    ],
    sampleRate: 0.3,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.05,
  });
}

const queryClient = new QueryClient();

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <LanguageContextProvider>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <App />
      </QueryClientProvider>
    </LanguageContextProvider>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
export { MonospacedText } from "./components/shared";
